module.exports = ".iframe-container {\n  overflow: hidden;\n  padding-top: 56.25%;\n  position: relative; }\n\n.iframe-container iframe {\n  border: 0;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/stage/containers/task-questions-container/task-questions-container.component.scss
// module id = ./src/app/stage/containers/task-questions-container/task-questions-container.component.scss
// module chunks = main